export default "__VITE_ASSET__3r2x3txh__"